var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUploadOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3337 0.333344H5.00033C2.61699 0.333344 0.688659 2.28334 0.688659 4.66668L0.666992 39.3333C0.666992 41.7167 2.59533 43.6667 4.97866 43.6667H31.0003C33.3837 43.6667 35.3337 41.7167 35.3337 39.3333V13.3333L22.3337 0.333344ZM31.0003 39.3333H5.00033V4.66668H20.167V15.5H31.0003V39.3333ZM9.33366 28.5217L12.3887 31.5767L15.8337 28.1533V37.1667H20.167V28.1533L23.612 31.5983L26.667 28.5217L18.022 19.8333L9.33366 28.5217Z",
    fill: "#0D1743"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadOutline);
export default __webpack_public_path__ + "static/media/cloud-upload-outline.b901f4e1f335ee0b3b6f7c9d08f8735a.svg";
export { ForwardRef as ReactComponent };